export const ProteinMyths = [
  
]
